import type { FeedbackMessages } from './en';

const it: FeedbackMessages = {
  qualified: {
    title: 'Grazie per aver completato questo studio!',
    text: 'Può chiudere la finestra del browser.\n\nSperiamo di rivederla presto.',
  },
  quotaFull: {
    title: 'Questo studio è concluso',
    text: 'Grazie per l’interesse mostrato verso il nostro studio.\n\nPurtroppo abbiamo già raccolto tutte le risposte di cui avevamo bisogno.\n\nSperiamo di rivederla in uno dei nostri futuri studi!',
  },
  terminated: {
    title: 'Grazie per aver condiviso il suo feedback!',
    text: 'Speriamo di rivederla presto nei nostri futuri studi. Nel frattempo, le auguriamo una splendida giornata.\n\nLa preghiamo di chiudere questa finestra del browser.',
  },
  mismatch: {
    title: 'Grazie per il suo interesse',
    text: 'Purtroppo non fa parte del gruppo target per questo specifico studio.\n\nPuò chiudere questa pagina.',
  },
  error: {
    title: 'Non siamo in grado di elaborare la sua richiesta',
    linkProblemDetailed:
      'Il link che ha seguito presenta dei problemi. Verifichi che il link nella barra degli indirizzi corrisponda a quello che le è stato fornito e riprovi.',
    linkProblemGeneric:
      'Il link che ha seguito presenta dei problemi. La preghiamo di riprovare.',
    contactPerson:
      'Se il problema persiste, la preghiamo di informare la persona da cui ha ricevuto il link.',
  },
};

export default it;
